import React, { useEffect, useMemo } from "react";
import { Grid } from "@mui/material";
import { useFieldArray, useFormContext } from "react-hook-form";
import i18next from "i18next";
import EAAutoCompleteInput from "components/inputs/EAAutoCompleteInput";
import { SearchFormInputBloc } from "components/lists-advanced-search/SearchFormInputBloc/SearchFormInputBloc";
import { SecurityRatingGlobalScoreMaturityEnum, SecurityRatingLetterScoreEnum } from "services/common/SecurityRatingUtils";

export function ThirdpartiesSearchSecurityRating({ filters }) {
  const { control, setValue } = useFormContext();

  const { fields } = useFieldArray({
    control,
    name: "securityRating",
  });

  useEffect(() => {
    if (filters?.securityRating) {
      filters.securityRating?.forEach((filter) => {
        const fieldIndex = fields.findIndex((field) => field.score === filter.score);
        setValue(`securityRating.${fieldIndex}.values`, filter.values || []);
      });
    }
  }, [fields, setValue, filters]);

  const securityRatingScoreMaturityOptions = useMemo(() => {
    return Object.keys(SecurityRatingGlobalScoreMaturityEnum).map(scoreKey => ({
      label: i18next.t(`securityRating.maturity.${SecurityRatingGlobalScoreMaturityEnum[scoreKey]}`),
      value: scoreKey,
    }))
  }, [])
  
  const securityRatingControlScoresOptions = useMemo(() => {
    return Object.values(SecurityRatingLetterScoreEnum).map(score => ({
      label: score,
      value: score,
    }))
  }, [])

  return (
    <>
      {fields.map((field, index) => {
        return (
          <Grid item xs={4} sm={3} md={2} key={field.id}>
            <SearchFormInputBloc label={"Security Rating " + i18next.t(`securityRating.scores.${field.score}`)} hasTooltip>
              <EAAutoCompleteInput
                fieldName={`securityRating.${index}.values`}
                options={field.score === 'global_score' ? securityRatingScoreMaturityOptions : securityRatingControlScoresOptions}
                placeholder={i18next.t("all")}
                variant="outlined"
                multiple
                limitTags={1}
              />
            </SearchFormInputBloc>
          </Grid>
        );
      })}
    </>
  );
}
